var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import WebhookIcon from '@mui/icons-material/Webhook';
import { Box, Paper } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { lazy, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getWebhooksAction } from '../../api/action/webhook.action';
import { QUERY_KEY } from '../../api/types/query.type';
import { useSettings } from '../../context/Settings';
import { theme } from './theme';
var AlertComponent = lazy(function () { return import('../../components/UIcomponents/AlertComponent/AlertComponent'); });
var Loader = lazy(function () { return import('../../components/UIcomponents/Loader'); });
var WebhookForm = lazy(function () { return import('../../components/Forms/WebhookForm'); });
var WebhookInfo = lazy(function () { return import('./components/WebhookInfo/WebhookInfo'); });
var Heading = lazy(function () { return import('../../components/UIcomponents/Heading'); });
var Webhooks = function (_a) {
    var shopId = _a.shopId;
    var t = useTranslation('settings').t;
    var _b = useSettings(), userPortal = _b.userPortal, isLoadingUserPortal = _b.isLoadingUserPortal, setShopSettings = _b.setShopSettings, shopSettings = _b.shopSettings;
    var _c = useQuery({
        queryKey: [QUERY_KEY.GET_WEBHOOKS, userPortal],
        queryFn: function () { return getWebhooksAction(shopId); },
        enabled: !!userPortal && !isLoadingUserPortal && !!shopId,
    }), webhooks = _c.data, isLoadingWebhooks = _c.isLoading, error = _c.error;
    var isWebhooks = !!(webhooks === null || webhooks === void 0 ? void 0 : webhooks.length);
    useEffect(function () {
        if (!webhooks)
            return;
        setShopSettings(function (prev) { return (__assign(__assign({}, prev), { isWebhookAdded: isWebhooks })); });
        // If webhooks are removed, also clear extra settings state
        if (!isWebhooks) {
            setShopSettings(function (prev) { return (__assign(__assign({}, prev), { isExtraSettingsAdded: false })); });
        }
    }, [webhooks, isWebhooks, setShopSettings]);
    if (isLoadingWebhooks || isLoadingUserPortal) {
        return (_jsx(Paper, { sx: theme.container, children: _jsx(Loader, { type: "form", fieldsCount: 1 }) }));
    }
    if (error) {
        return (_jsx(Paper, { sx: theme.container, children: _jsx(AlertComponent, { type: "error", message: t('webhook.error.getWebhooks') }) }));
    }
    return (_jsxs(Paper, { sx: theme.container, children: [_jsxs(Box, { sx: theme.heading, children: [_jsx(WebhookIcon, { sx: shopSettings.isWebhookAdded ? theme.iconCompleted : undefined }), _jsx(Heading, { title: "webhook.title" })] }), !isWebhooks ? (_jsxs(_Fragment, { children: [_jsx(AlertComponent, { type: "warning", message: t('webhook.howToGetWebhook').replace('{BASE_URL}', userPortal ? "https://".concat(userPortal) : "https://".concat(window.location.host)) }), _jsx(WebhookForm, { shopId: shopId })] })) : (_jsx(WebhookInfo, { webhooks: webhooks, shopId: shopId }))] }));
};
export default Webhooks;
